import type { PropsWithChildren } from 'react'

import classNames from 'classnames'

export interface GridItemProps {
  colSpan:
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
  flex?: boolean
  padding?: boolean
}

export const GridItem: React.FC<PropsWithChildren<GridItemProps>> = ({
  children,
  colSpan = '2',
  flex = true,
  padding = false,
}) => {
  return (
    <div
      className={classNames('w-full items-start justify-center', {
        'col-span-1': colSpan === '1',
        'col-span-2': colSpan === '2',
        'col-span-3': colSpan === '3',
        'col-span-4': colSpan === '4',
        'col-span-5': colSpan === '5',
        'col-span-6': colSpan === '6',
        'col-span-7': colSpan === '7',
        'col-span-8': colSpan === '8',
        'col-span-9': colSpan === '9',
        'col-span-10': colSpan === '10',
        'col-span-11': colSpan === '11',
        'col-span-12': colSpan === '12',
        flex: flex,
        'py-4 px-2': padding,
      })}
    >
      {children}
    </div>
  )
}
